module.exports = __webpack_public_path__ + "images/sixt_small420782f91300824eb86bd971401547f7.png";